import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import WarehouseRegModal from "../../../../modal/PC/gijun/WarehouseRegModal";
import WarehouseUpdateModal from "../../../../modal/PC/gijun/WarehouseUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const Warehouse = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search: '',
        workplace_id: 0
    });
    const [workplaceOption, setWorkplaceOption] = useState([]);
    const [workplaceModalOption, setWorkplaceModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectWarehouseID, setSelectWarehouseID] = useState('');

    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
                {
                    field: 'updated',
                    headerName: '수정',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
                (MenuDeleteExistYN === "Y"?
                {
                    field: 'deleted',
                    headerName: '삭제',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            { field: 'id', headerName: 'warehouse_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'workplace_id', headerName: 'workplace_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'workplace_name', headerName: '사업장', width: 250, headerAlign: 'center', align:'left' },
            { field: 'warehouse_name', headerName: '창고명', width: 250, headerAlign: 'center', align:'left' },
            { field: 'warehouse_width', headerName: '창고가로', width: 120, headerAlign: 'center', align:'right' },
            { field: 'warehouse_depth', headerName: '창고세로', width: 120, headerAlign: 'center', align:'right' },
            { field: 'warehouse_height', headerName: '창고높이', width: 120, headerAlign: 'center', align:'right' },
            { field: 'warehouse_reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'warehouse_reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'warehouse_update_user_name', headerName: '수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'warehouse_update_datetime', headerName: '수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        workplace_id: false,
        workplace_name: true,
        warehouse_name: true,
        warehouse_width: true,
        warehouse_depth: true,
        warehouse_height: true,
        warehouse_reg_user_name: true,
        warehouse_reg_datetime: true,
        warehouse_update_user_name: true,
        warehouse_update_datetime: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.workplace_id])

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Warehouse/List',
          {
            params : { 
                search: keyword.search,
                workplace_id: keyword.workplace_id 
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.warehouse_id]) {
                    PermissionMap[row.warehouse_id] = [row.warehouse_reg_user_id, row.warehouse_update_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            const array = response.data.map((item, index) => ({
                id: item.warehouse_id,
                workplace_id: item.workplace_id,
                workplace_name: item.workplace_name,
                warehouse_name: item.warehouse_name,
                warehouse_width: item.warehouse_width,
                warehouse_depth: item.warehouse_depth,
                warehouse_height: item.warehouse_height,
                warehouse_reg_user_name: item.warehouse_reg_user_name,
                warehouse_reg_datetime: Moment(item.warehouse_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
                warehouse_update_user_name: item.warehouse_update_user_name,
                warehouse_update_datetime:(item.warehouse_update_datetime === undefined?'':Moment(item.warehouse_update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.warehouse_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set(array.map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    }

    const handleInitSelect = () => {
        //사업장
        axios.get('/api/Common/WorkplaceList')
        .then((response) => {
            var array = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );
            array.unshift({ value: 0, label : '사업장'});
            var array_modal = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );
            setWorkplaceOption(array);
            setWorkplaceModalOption(array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            workplace_id: 0,
            search: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            workplace_id: false,
            workplace_name: true,
            warehouse_name: true,
            warehouse_width: true,
            warehouse_depth: true,
            warehouse_height: true,
            warehouse_reg_user_name: true,
            warehouse_reg_datetime: true,
            warehouse_update_user_name: true,
            warehouse_update_datetime: true,
            deleted: true,
            updated: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('창고 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('창고 수정');
        setSelectWarehouseID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '창고 '+object.row.warehouse_name+' 삭제',
            html : '창고 '+object.row.warehouse_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Warehouse/Delete', new URLSearchParams({
                    delete_warehouse_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '창고 '+object.row.warehouse_name+' 삭제 완료',
                            text: '정상적으로 창고 '+object.row.warehouse_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    const handleRegSuccessSave = (regID) => {
        setModalTitle('창고 수정');
        setRegModalOpen(false);
        handleView();
        
        Swal.fire({
            title: '창고 등록 완료',
            text: '정상적으로 창고가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectWarehouseID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '창고관리'
        axios.get('/api/p/Warehouse/Excel',
        {   
            params : { search: keyword.search, workplace_id: keyword.workplace_id, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <WarehouseRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        workplaceModalOption={workplaceModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            사업장
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="사업장" onChange={(e) => onSelectChange('workplace_id',e.value)} value={workplaceOption.filter(function (option) { return option.value === keyword.workplace_id;  })} options={workplaceOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <WarehouseUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectWarehouseID}
                        originRows={originRows.filter(row => String(row.warehouse_id) === String(selectWarehouseID))}
                        handleView={handleView}
                        workplaceModalOption={workplaceModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Warehouse;
